import React from 'react';
import { styled } from '@teko/ui';

const HorizontalSelectList = styled.ul`
  display: flex;
  background-color: white;
  padding: 0;
  margin: 0;
  border-radius: 5px;
  overflow: hidden;
  box-shadow: 5px 5px 20px 0px rgba(230, 230, 230, 1);
`;
const HorizontalSelectItem = styled.li(({ selected, theme }) => `
  list-style-type: none;
  padding: 0.6rem;
  font-size: 0.95rem;
  color: ${selected ? theme == null ? void 0 : theme.brand.primary : "#999"};
  background-color: ${selected ? "#f9f9f9" : "white"};

  cursor: pointer;
  transition-duration: 0.1s;

  &:hover {
    background-color: #f9f9f9;
    color: ${theme == null ? void 0 : theme.brand.primary};
  }
  `);
const HorizontalSelect = ({ items, onChange, selected }) => {
  return /* @__PURE__ */ React.createElement(HorizontalSelectList, null, items.map(({ value, content }, index) => /* @__PURE__ */ React.createElement(HorizontalSelectItem, {
    key: index,
    onClick: () => onChange(value),
    selected: value === selected
  }, content)));
};

export { HorizontalSelect };
